import { mapGetters, mapActions } from 'vuex';
import GcButton from '@garmin/components-global/src/components/GcButton/index.vue';
import GcHeading from '@garmin/components-global/src/components/GcHeading/index.vue';
import templateBuilder from '@/helpers/templateBuilder';
import ProductCard from '@/components/ProductCard/index.vue';

export default {
  name: 'Interstitial',
  props: {
    description: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    altText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      className: 'app__product__interstitial',
    };
  },
  mounted() {
    this.displayWindow();

    // Scroll the window to top to make sure user sees that the product was added to cart
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  },
  computed: {
    productAddedClass() {
      return `${this.className}__added`;
    },
    containerClass() {
      return `${this.className}__container`;
    },
    productImageClass() {
      return `${this.className}__image`;
    },
    productDetailsClass() {
      return `${this.className}__details`;
    },
    productDetailsTitleClass() {
      return `${this.productDetailsClass}__title`;
    },
    productDetailsNameClass() {
      return `${this.productDetailsClass}__name`;
    },
    productBtnsClass() {
      return `${this.className}__buttons`;
    },
    continueShoppingClass() {
      return `${this.className}__continue_shopping`;
    },
    viewCartClass() {
      return `${this.className}__view_cart`;
    },
    accessoriesClass() {
      return `${this.className}__accessories`;
    },
    accessoryClass() {
      return `${this.className}__accessory`;
    },
    accessoriesContainerClass() {
      return `${this.className}__accessories__container`;
    },
    checkIconClass() {
      return `${this.className}__check-icon`;
    },
    loaderClass() {
      return `${this.className}__loader`;
    },
    showInterstitial() {
      return this.isVisible && this.shouldDisplay;
    },
    activeInterstitialAccessories() {
      return this.interstitialAccessories(this.partNumber);
    },
    ...mapGetters({
      partNumber: 'getPartNumber',
      seoUrl: 'getSeoUrl',
      viewCartUrl: 'getViewCartUrl',
      isVisible: 'getInterstitialIsVisible',
      shouldDisplay: 'getInterstitialShouldDisplay',
      interstitialAccessories: 'getInterstitialAccessories',
      addedToCart: 'getAddedToCart',
      continueShopping: 'getContinueShopping',
      viewCart: 'getViewCart',
      shopForAccessories: 'getShopForAccessories',
    }),
  },
  methods: {
    async displayWindow() {
      // We render the component
      this.setInterstitialShouldDisplay(true);
    },
    getSeoUrl(seoUrl) {
      return templateBuilder(this.seoUrl, { seoUrl });
    },
    handleContinueShopping(e) {
      e.preventDefault();
      this.setInterstitialIsVisible(false);
      this.setInterstitialShouldDisplay(false);
    },
    productPrice(product) {
      return product.priceObj && product.priceObj.price;
    },
    productSalePrice(product) {
      return product.priceObj && product.priceObj.salePrice;
    },
    productGAEvent(product) {
      const displayName = product.displayName.replace(',', '');
      const { partNumber } = product;
      return `Product Page, Interstitial, ${displayName} ${partNumber}`;
    },
    ...mapActions([
      'setInterstitialIsVisible',
      'setInterstitialShouldDisplay',
    ]),
  },
  components: {
    GcButton,
    GcHeading,
    ProductCard,
  },
};
